import { NavLink } from 'react-router-dom';

import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

export const TruncatedText = styled('span')(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const Root = styled(MenuItem)(({ theme }) => ({
  padding: '0',

  '&.MuiMenuItem-root.is-divider': {
    borderTop: `1px solid ${theme.palette.focus20.light}`,
    display: 'block',
    lineHeight: 'none',
    minHeight: 'auto'
  },

  '&:not(.is-divider) > *': {
    paddingBlock: '0.75rem',

    [theme.breakpoints.up('lg')]: {
      paddingBlock: '1.125rem'
    }
  },

  '&.Mui-focusVisible, &:hover, & .active': {
    background: 'rgba(207, 249, 250, 0.4)'
  }
}));

export const Link = styled(NavLink)(() => ({
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  textDecoration: 'none',
  textTransform: 'capitalize'
}));
